class imageDialogController {
    constructor() {}

    $onInit() {}
}

export default imageDialogController;
